import React from "react";
import styled from "styled-components";

import { graphql, useStaticQuery } from "gatsby";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import BackgroundImage from "gatsby-background-image";
// import SEO from "../components/seo";

import { Helmet } from "react-helmet";

const HomePg = () => {
  const motion = (e, it) => {
    it.forEach((mv) => {
      const speed = mv.getAttribute("data-speed");

      const x = (window.innerWidth - e.pageX * speed) / 100;
      const y = (window.innerWidth - e.pageY * speed) / 100;

      mv.style.transform = `translateX(${x}px) translateY(${y}px)`;
    });
  };
  React.useEffect(() => {
    const hero = document.querySelector(".home_cover");
    const logo = hero.querySelector(".movx");
    const walk = 11; // 500px
    const itmmvx = document.querySelectorAll(".movx");

    function shadow(e) {
      const { offsetWidth: width, offsetHeight: height } = hero;
      let { offsetX: x, offsetY: y } = e;

      if (this !== e.target) {
        x = x + e.target.offsetLeft;
        y = y + e.target.offsetTop;
      }

      const xWalk = Math.round((x / width) * walk - walk / 2);
      const yWalk = Math.round((y / height) * walk - walk / 2);

      logo.style.setProperty(
        "-webkit-filter",
        `drop-shadow(${xWalk}px ${yWalk}px 0 rgba(162, 186, 64, 0.461)) drop-shadow(${
          xWalk * -1
        }px ${yWalk}px 0 rgba(170, 103, 74, 0.517))`
      );
    }

    hero.addEventListener("mousemove", shadow);

    window.addEventListener("mousemove", (e) => motion(e, itmmvx));
  });

  const { desktop_m, hsLogo } = useStaticQuery(
    graphql`
      query {
        desktop_m: file(relativePath: { eq: "cover.jpeg" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        hsLogo: file(relativePath: { eq: "hs.png" }) {
          childImageSharp {
            gatsbyImageData(
              width: 436
              placeholder: BLURRED
              formats: [AUTO, WEBP, AVIF]
            )
          }
        }
      }
    `
  );

  // Set ImageData.
  const imageData = desktop_m.childImageSharp.fluid;
  const image = getImage(hsLogo);

  return (
    <>
      <Helmet
        title="Home | Hes Sound"
        meta={[
          {
            name: `description`,
            content: `Underground House Music Event Poland Bialystok Warsaw Europe Hes
          Sound. Not just a Sound system, not just a collective, not just a
          party`,
          },
          {
            property: `og:description`,
            content: `Underground House Music Event Poland Bialystok Warsaw Europe Hes
          Sound. Not just a Sound system, not just a collective, not just a
          party`,
          },
          {
            property: `og:type`,
            content: `website`,
          },
        ].concat([])}
      >
        {console.log(`Underground House Music Event Poland Bialystok Warsaw Europe Hes
          Sound. Not just a Sound system, not just a collective, not just a
          party`)}
        <meta charSet="utf-8" />
      </Helmet>
      {/* <SEO title={`Hes Sound | Home`} /> */}
      <HomeCss>
        <p className="visually_hidden">
          Underground House Music Event Poland Bialystok Warsaw Europe Hes
          Sound. Not just a Sound system, not just a collective, not just a
          party.
        </p>
        <BackgroundImage
          Tag="div"
          fluid={imageData}
          className="home_cover"
          backgroundColor="#040e18"
        >
          <div className="movx" data-speed="1">
            <GatsbyImage className="hs_logo" image={image} alt={"testimage"} />
          </div>
          <div className="contact_links contact_links--cover">
            <a
              href="https://ra.co/promoters/122854"
              target="_blank"
              className="contact_link contact_link--ra"
              rel="noreferrer"
            >
              {/* <span> Resident Advisor</span> */}
            </a>
            <a
              href="https://soundcloud.com/hes_sound"
              target="_blank"
              className="contact_link contact_link--sc"
              rel="noreferrer"
            >
              {/* <span> SoundCloud</span> */}
            </a>
            <a
              href="https://www.instagram.com/hes_sound/"
              target="_blank"
              className="contact_link contact_link--inst"
              rel="noreferrer"
            >
              {/* <span> Instagram</span> */}
            </a>
          </div>
        </BackgroundImage>
      </HomeCss>
    </>
  );
};

const HomeCss = styled.div`
  scroll-behavior: smooth;
  height: 100vh;
  background-image: url(data:image/svg+xml;base64,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);
  .home_cover {
    background-size: cover;
    width: 100vw;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
  }

  .movx {
    filter: drop-shadow(6px 6px 0 rgba(31, 107, 201, 0.386))
      drop-shadow(6px -6px 0 rgba(188, 122, 47, 0.586));
    font-size: 100px;
    border-radius: 21px;
  }

  .home_cover:before,
  .home_cover:after {
    background-position: 89% bottom !important;
  }

  @media screen and (max-width: 510px) {
    height: 100vh;
  }
  @media screen and (max-height: 692px) {
    height: 100vh;
  }
`;

export default HomePg;
